/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LoginLinkRouteImport } from './routes/login-link'
import { Route as BookBookIdRouteImport } from './routes/book.$bookId'
import { Route as BookNewRouteImport } from './routes/book.new'
import { Route as BookBookIdEditorRouteImport } from './routes/book.$bookId.editor'
import { Route as BookBookIdSetupRouteImport } from './routes/book.$bookId.setup'
import { Route as BookBookIdStatsRouteImport } from './routes/book.$bookId.stats'
import { Route as BookBookIdContentPartNumberChapterNumberRouteImport } from './routes/book.$bookId.content.$partNumber.$chapterNumber'
import { Route as BookBookIdPlanPartNumberChapterNumberRouteImport } from './routes/book.$bookId.plan.$partNumber.$chapterNumber'

const LoginLazyRouteImport = createFileRoute('/login')()

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginLazyRoute = LoginLazyRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/login.lazy').then((d) => d.Route))
const LoginLinkRoute = LoginLinkRouteImport.update({
  id: '/login-link',
  path: '/login-link',
  getParentRoute: () => rootRouteImport,
} as any)
const BookBookIdRoute = BookBookIdRouteImport.update({
  id: '/book/$bookId',
  path: '/book/$bookId',
  getParentRoute: () => rootRouteImport,
} as any)
const BookNewRoute = BookNewRouteImport.update({
  id: '/book/new',
  path: '/book/new',
  getParentRoute: () => rootRouteImport,
} as any)
const BookBookIdEditorRoute = BookBookIdEditorRouteImport.update({
  id: '/editor',
  path: '/editor',
  getParentRoute: () => BookBookIdRoute,
} as any)
const BookBookIdSetupRoute = BookBookIdSetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => BookBookIdRoute,
} as any)
const BookBookIdStatsRoute = BookBookIdStatsRouteImport.update({
  id: '/stats',
  path: '/stats',
  getParentRoute: () => BookBookIdRoute,
} as any)
const BookBookIdContentPartNumberChapterNumberRoute =
  BookBookIdContentPartNumberChapterNumberRouteImport.update({
    id: '/content/$partNumber/$chapterNumber',
    path: '/content/$partNumber/$chapterNumber',
    getParentRoute: () => BookBookIdRoute,
  } as any)
const BookBookIdPlanPartNumberChapterNumberRoute =
  BookBookIdPlanPartNumberChapterNumberRouteImport.update({
    id: '/plan/$partNumber/$chapterNumber',
    path: '/plan/$partNumber/$chapterNumber',
    getParentRoute: () => BookBookIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login-link': typeof LoginLinkRoute
  '/login': typeof LoginLazyRoute
  '/book/$bookId': typeof BookBookIdRouteWithChildren
  '/book/new': typeof BookNewRoute
  '/book/$bookId/editor': typeof BookBookIdEditorRoute
  '/book/$bookId/setup': typeof BookBookIdSetupRoute
  '/book/$bookId/stats': typeof BookBookIdStatsRoute
  '/book/$bookId/content/$partNumber/$chapterNumber': typeof BookBookIdContentPartNumberChapterNumberRoute
  '/book/$bookId/plan/$partNumber/$chapterNumber': typeof BookBookIdPlanPartNumberChapterNumberRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login-link': typeof LoginLinkRoute
  '/login': typeof LoginLazyRoute
  '/book/$bookId': typeof BookBookIdRouteWithChildren
  '/book/new': typeof BookNewRoute
  '/book/$bookId/editor': typeof BookBookIdEditorRoute
  '/book/$bookId/setup': typeof BookBookIdSetupRoute
  '/book/$bookId/stats': typeof BookBookIdStatsRoute
  '/book/$bookId/content/$partNumber/$chapterNumber': typeof BookBookIdContentPartNumberChapterNumberRoute
  '/book/$bookId/plan/$partNumber/$chapterNumber': typeof BookBookIdPlanPartNumberChapterNumberRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login-link': typeof LoginLinkRoute
  '/login': typeof LoginLazyRoute
  '/book/$bookId': typeof BookBookIdRouteWithChildren
  '/book/new': typeof BookNewRoute
  '/book/$bookId/editor': typeof BookBookIdEditorRoute
  '/book/$bookId/setup': typeof BookBookIdSetupRoute
  '/book/$bookId/stats': typeof BookBookIdStatsRoute
  '/book/$bookId/content/$partNumber/$chapterNumber': typeof BookBookIdContentPartNumberChapterNumberRoute
  '/book/$bookId/plan/$partNumber/$chapterNumber': typeof BookBookIdPlanPartNumberChapterNumberRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login-link'
    | '/login'
    | '/book/$bookId'
    | '/book/new'
    | '/book/$bookId/editor'
    | '/book/$bookId/setup'
    | '/book/$bookId/stats'
    | '/book/$bookId/content/$partNumber/$chapterNumber'
    | '/book/$bookId/plan/$partNumber/$chapterNumber'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login-link'
    | '/login'
    | '/book/$bookId'
    | '/book/new'
    | '/book/$bookId/editor'
    | '/book/$bookId/setup'
    | '/book/$bookId/stats'
    | '/book/$bookId/content/$partNumber/$chapterNumber'
    | '/book/$bookId/plan/$partNumber/$chapterNumber'
  id:
    | '__root__'
    | '/'
    | '/login-link'
    | '/login'
    | '/book/$bookId'
    | '/book/new'
    | '/book/$bookId/editor'
    | '/book/$bookId/setup'
    | '/book/$bookId/stats'
    | '/book/$bookId/content/$partNumber/$chapterNumber'
    | '/book/$bookId/plan/$partNumber/$chapterNumber'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginLinkRoute: typeof LoginLinkRoute
  LoginLazyRoute: typeof LoginLazyRoute
  BookBookIdRoute: typeof BookBookIdRouteWithChildren
  BookNewRoute: typeof BookNewRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login-link': {
      id: '/login-link'
      path: '/login-link'
      fullPath: '/login-link'
      preLoaderRoute: typeof LoginLinkRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/book/$bookId': {
      id: '/book/$bookId'
      path: '/book/$bookId'
      fullPath: '/book/$bookId'
      preLoaderRoute: typeof BookBookIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/book/new': {
      id: '/book/new'
      path: '/book/new'
      fullPath: '/book/new'
      preLoaderRoute: typeof BookNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/book/$bookId/editor': {
      id: '/book/$bookId/editor'
      path: '/editor'
      fullPath: '/book/$bookId/editor'
      preLoaderRoute: typeof BookBookIdEditorRouteImport
      parentRoute: typeof BookBookIdRoute
    }
    '/book/$bookId/setup': {
      id: '/book/$bookId/setup'
      path: '/setup'
      fullPath: '/book/$bookId/setup'
      preLoaderRoute: typeof BookBookIdSetupRouteImport
      parentRoute: typeof BookBookIdRoute
    }
    '/book/$bookId/stats': {
      id: '/book/$bookId/stats'
      path: '/stats'
      fullPath: '/book/$bookId/stats'
      preLoaderRoute: typeof BookBookIdStatsRouteImport
      parentRoute: typeof BookBookIdRoute
    }
    '/book/$bookId/content/$partNumber/$chapterNumber': {
      id: '/book/$bookId/content/$partNumber/$chapterNumber'
      path: '/content/$partNumber/$chapterNumber'
      fullPath: '/book/$bookId/content/$partNumber/$chapterNumber'
      preLoaderRoute: typeof BookBookIdContentPartNumberChapterNumberRouteImport
      parentRoute: typeof BookBookIdRoute
    }
    '/book/$bookId/plan/$partNumber/$chapterNumber': {
      id: '/book/$bookId/plan/$partNumber/$chapterNumber'
      path: '/plan/$partNumber/$chapterNumber'
      fullPath: '/book/$bookId/plan/$partNumber/$chapterNumber'
      preLoaderRoute: typeof BookBookIdPlanPartNumberChapterNumberRouteImport
      parentRoute: typeof BookBookIdRoute
    }
  }
}

interface BookBookIdRouteChildren {
  BookBookIdEditorRoute: typeof BookBookIdEditorRoute
  BookBookIdSetupRoute: typeof BookBookIdSetupRoute
  BookBookIdStatsRoute: typeof BookBookIdStatsRoute
  BookBookIdContentPartNumberChapterNumberRoute: typeof BookBookIdContentPartNumberChapterNumberRoute
  BookBookIdPlanPartNumberChapterNumberRoute: typeof BookBookIdPlanPartNumberChapterNumberRoute
}

const BookBookIdRouteChildren: BookBookIdRouteChildren = {
  BookBookIdEditorRoute: BookBookIdEditorRoute,
  BookBookIdSetupRoute: BookBookIdSetupRoute,
  BookBookIdStatsRoute: BookBookIdStatsRoute,
  BookBookIdContentPartNumberChapterNumberRoute:
    BookBookIdContentPartNumberChapterNumberRoute,
  BookBookIdPlanPartNumberChapterNumberRoute:
    BookBookIdPlanPartNumberChapterNumberRoute,
}

const BookBookIdRouteWithChildren = BookBookIdRoute._addFileChildren(
  BookBookIdRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginLinkRoute: LoginLinkRoute,
  LoginLazyRoute: LoginLazyRoute,
  BookBookIdRoute: BookBookIdRouteWithChildren,
  BookNewRoute: BookNewRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
